// extracted by mini-css-extract-plugin
export var storyDisplay = "home-module--storyDisplay--3_3MG";
export var dividerSpace = "home-module--dividerSpace--2F0qX";